$.fn.collectionRequestPage = function () {
  function isInCollectionRequestPage() {
    return $("#collection-request-page").length > 0;
  }
  function isInSubmissionsPage() {
    return $("#submissions-page").length > 0;
  }

  function isInGrantSpecifiedAmountsPage() {
    return $("#grant-specified-amounts-page").length > 0;
  }
  function isInSpecifiedAmountsPage() {
    return $("#specified-amounts-page").length > 0;
  }
  function isInConfirmReviewPage() {
    return $("#confirm-review-page").length > 0;
  }
  function isInStartReviewPage() {
    return $("#start-review-page").length > 0;
  }
  function isInApproveReviewPage() {
    return $("#approve-review-page").length > 0;
  }
  function isInDownloadTemplatePage() {
    return $("#download-template-page").length > 0;
  }
  function isSelectFinancialYearPage() {
    return $("#selectFinancialYearPage").length > 0;
  }
  function isUploadSuccessPage() {
    return $("#upload-success-page").length > 0;
  }
  function isInGrid() {
    return $(".jsgrid-table").length > 0;
  }
  function containsFileUpload() {
    return $(".file-upload-container").length > 0;
  }
  function containsSelectAll() {
    return $(".table-checkbox").length > 0;
  }
  function isInUserListPage() {
    return $("#userslist-page").length > 0;
  }

  function isInDashboardPage() {
    return $("#dashboard-page").length > 0;
  }

  function isInScheamAssociatePage() {
    return $("#associateSchemaDefCommand").length > 0;
  }
  function isInSelectFinancialYearPage() {
    return $("#select-financial-year").length > 0;
  }
  if (isInSubmissionsPage()) {
    //        window.scrollTo(0, 0);
    $(document).ready(function () {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
      //            $(this).scrollTop(0);
    });
  }

  if (isInSpecifiedAmountsPage()) {
    var downloadHref = $("#downloadTemplates").attr("href");
    var baseHref = downloadHref;
    var associatedBaseHref = baseHref + "&templateType=associated-with-dataset";

    var classificationHref = baseHref + "&templateType=in-a-classification";

    var blankHref = baseHref + "&templateType=none";

    var orgAssociated = true;
    var notifyHref = $("#notifyOwners").attr("href");
    var baseNotifyHref = notifyHref;
    var associatedNotifyHref =
      baseNotifyHref + "&templateType=associated-with-dataset";
    var classificationNotifyHref =
      baseNotifyHref + "&templateType=in-a-classification";
    var blankNotifyHref = baseNotifyHref + "&templateType=none";

    var instanceTempParam =
      associatedBaseHref + "&datasetId=" + $("#instanceId").val();
    var instanceMailParam =
      associatedNotifyHref + "&datasetId=" + $("#instanceId").val();
    //        console.log("---------------instance mail param------------------");
    //        console.log(instanceMailParam);
    //        console.log(instanceTempParam);

    $("#downloadTemplates").attr("href", instanceTempParam);
    $("#notifyOwners").attr("href", instanceMailParam);
    var newDownloadHref = baseHref;
    var newNotifyHref = baseNotifyHref;

    $("#allOrganisation").on("change", function () {
      if ($(this).is(":checked") == true) {
        var instanceVal = $("#instanceId").val();
        if (instanceVal != "") {
          $("#downloadTemplates").attr(
            "href",
            associatedBaseHref + "&datasetId=" + instanceVal,
          );
          $("#notifyOwners").attr(
            "href",
            associatedNotifyHref + "&datasetId=" + instanceVal,
          );
        } else {
          $("#downloadTemplates").attr("href", associatedBaseHref);
          $("#notifyOwners").attr("href", associatedNotifyHref);
        }
        $("#classificationIds").closest(".form-group").attr("hidden", "hidden");
        $("#classificationIds").val("").trigger("chosen:updated");
        newDownloadHref = baseHref + "&templateType=associated-with-dataset";
        newNotifyHref =
          baseNotifyHref + "&templateType=associated-with-dataset";
        orgAssociated = true;
        //                $('#instanceId').closest('.form-group').removeAttr('hidden');
      } else {
        orgAssociated = false;
      }
    });
    $("#currentOrganisation").on("change", function () {
      if ($(this).is(":checked") == true) {
        var instanceVal = $("#instanceId").val();
        if (instanceVal != "") {
          $("#downloadTemplates").attr(
            "href",
            classificationHref + "&datasetId=" + instanceVal,
          );
          $("#notifyOwners").attr(
            "href",
            classificationNotifyHref + "&datasetId=" + instanceVal,
          );
        } else {
          $("#downloadTemplates").attr("href", classificationHref);
          $("#notifyOwners").attr("href", classificationNotifyHref);
        }
        $("#classificationIds").closest(".form-group").removeAttr("hidden");
        newDownloadHref = baseHref + "&templateType=in-a-classification";
        newNotifyHref = baseNotifyHref + "&templateType=in-a-classification";
        //                $('#instanceId').closest('.form-group').attr('hidden', 'hidden');
      }
    });
    $("#blank").on("change", function () {
      if ($(this).is(":checked") == true) {
        var instanceVal = $("#instanceId").val();
        if (instanceVal != "") {
          $("#downloadTemplates").attr(
            "href",
            blankHref + "&datasetId=" + instanceVal,
          );
          $("#notifyOwners").attr(
            "href",
            blankNotifyHref + "&datasetId=" + instanceVal,
          );
        } else {
          $("#downloadTemplates").attr("href", blankHref);
          $("#notifyOwners").attr("href", blankNotifyHref);
        }
        $("#classificationIds").val("").trigger("chosen:updated");
        $("#classificationIds").closest(".form-group").attr("hidden", "hidden");
        newDownloadHref = baseHref + "&templateType=none";
        newNotifyHref = baseNotifyHref + "&templateType=none";
        //                $('#instanceId').closest('.form-group').attr('hidden', 'hidden');
      }
    });
    $("#classificationIds").on("change", function () {
      var currentHref = newDownloadHref;
      var currentNotifyHref = newNotifyHref;
      var instanceVal = $("#instanceId").val();
      var classifications = $(this).val();
      for (var i in classifications) {
        currentHref =
          currentHref + "&classifications[" + i + "]=" + classifications[i];
        currentNotifyHref =
          currentNotifyHref +
          "&classifications[" +
          i +
          "]=" +
          classifications[i];
      }
      if (instanceVal != "") {
        currentHref = currentHref + "&datasetId=" + instanceVal;
        currentNotifyHref = currentNotifyHref + "&datasetId=" + instanceVal;
      }
      $("#downloadTemplates").attr("href", currentHref);
      $("#notifyOwners").attr("href", currentNotifyHref);
    });
    $("#instanceId").on("change", function () {

      var currentHref = $("#downloadTemplates")
        .attr("href")
        .split("&datasetId=")[0];
      //            console.log(currentHref);
      var currentNotifyHref = $("#notifyOwners")
        .attr("href")
        .split("&datasetId=")[0];

      currentHref = currentHref + "&datasetId=" + $(this).val();
      currentNotifyHref = currentNotifyHref + "&datasetId=" + $(this).val();
      $("#downloadTemplates").attr("href", currentHref);
      $("#notifyOwners").attr("href", currentNotifyHref);
    });

    if ($("#certifiedInstances").val() != null) {
      if (!$("#certifiedInstances").val().includes("not-started")) {
        $("#cancelTransaction").closest(".form-group").removeAttr("hidden");
        $("#file").attr("disabled", "disabled");
        $("#statusText").removeAttr("hidden");
        $("#collectionInstance").val(
          $("#certifiedInstances option:selected").text(),
        );
      } else {
        $("#statusText").attr("hidden", "hidden");
        $("#file").removeAttr("disabled");
        $("#collectionInstance").val(
          $("#certifiedInstances option:selected").text(),
        );
      }
    }

    $("#certifiedInstances").on("change", function () {
      if (!$(this).val().includes("not-started")) {
        $("#cancelTransaction").closest(".form-group").removeAttr("hidden");
        $("#file").attr("disabled", "disabled");
        $("#statusText").removeAttr("hidden");
      } else {
        $("#cancelTransaction").closest(".form-group").attr("hidden", "hidden");
        $("#statusText").attr("hidden", "hidden");
        $("#file").removeAttr("disabled");
      }
      $("#collectionInstance").val(
        $("#certifiedInstances option:selected").text(),
      );
    });

    $("#cancelTransaction").on("change", function () {
      if ($(this).prop("checked") == true) {
        //                console.log("checked is true");
        $("#statusText").attr("hidden", "hidden");
        $("#file").removeAttr("disabled");
      } else {
        //                console.log("unchecked");
        $("#statusText").removeAttr("hidden");
        $("#file").attr("disabled", "disabled");
      }
    });

    var tempType = $("#tempType").val();
    if (tempType == "none") {
      $("#blank").attr("checked", "checked");
      $("#blank").closest("label").addClass("selected");
      $("#allOrganisation").closest("label").removeClass("selected");
      $("#allOrganisation").removeAttr("checked");
    }
    if (tempType == "associated-with-dataset") {
      $("#allOrganisation").attr("checked", "checked");
    }
    if (tempType == "in-a-classification") {
      $("#currentOrganisation").attr("checked", "checked");
      $("#currentOrganisation").closest("label").addClass("selected");
      $("#allOrganisation").closest("label").removeClass("selected");
      $("#allOrganisation").removeAttr("checked");
      $("#classificationIds").closest(".form-group").removeAttr("hidden");
    }



  }

  if (containsFileUpload()) {
    $(".file-upload-container").keypress(function (e) {
      if (e.keyCode == 13) {
        $(this).find("input").click();
        //            $('#file').click();
      }
    });
  }

  if (isInDashboardPage()) {
    var $element = $(
      "<thead hidden>\
                            <th hidden>header</th>\
                          </thead>",
    );
    $(".jsgrid-grid-header table").append($element);
  }

  if (containsSelectAll()) {
    var $headerSpan = $('<span class="visually-hidden">Header checkbox</span>');
    $(".jsgrid-table th.table-checkbox").append($headerSpan);
    $(".jsgrid-insert-row td.table-checkbox span input").attr(
      "aria-label",
      "grid checkbox",
    );
  }

  if (isInGrantSpecifiedAmountsPage()) {
    var downloadHref = $("#downloadTemplate").attr("href");
    if ($("#allowAllSections").is(":checked")) {
      $("#grantSections").closest(".govuk-form-group").attr("hidden", "hidden");
      $("#grantSections").val("");
    }
    $("#allowAllSections").click(function () {
      if ($("#allowAllSections").is(":checked")) {
        $("#grantSections")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
        $("#grantSections").val("").trigger("chosen:updated");
        /* $('#downloadTemplate').attr('href', downloadHref);*/
        $("#downloadTemplate").attr("disabled", false);
      } else {
        $("#grantSections").closest(".govuk-form-group").removeAttr("hidden");
      }
    });
    $("#allowParticularSections").click(function () {
      if ($("#allowParticularSections").is(":checked")) {
        $("#grantSections").closest(".govuk-form-group").removeAttr("hidden");
        $("#downloadTemplate").attr("disabled", true);
      } else {
        $("#grantSections")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
        $("#grantSections").val("").trigger("chosen:updated");
        $("#downloadTemplate").attr("disabled", false);
      }
    });

    $("#downloadTemplate").click(function (e) {
      // Download claim amounts template
      e.preventDefault();
      var currentUrl = $("#downloadTemplate").attr("href");
      var newHref = "";
      if (
        $("#grantSections").val() != undefined &&
        $("#grantSections").val().length > 0
      ) {
        var selectedGrants = $("#grantSections").val();

        selectedGrants.forEach(function (val, index) {
          newHref += "&grantSections%5B" + index + "%5D=" + val; // %5B and %5D are url-encoded [ and ]
        });
      }
      var selectedOrgs = $("#organisations").val();
      if (selectedOrgs.length > 0 && selectedOrgs[0]) {
        selectedOrgs.forEach(function (val, index) {
          newHref += "&organisations%5B" + index + "%5D=" + val;  // %5B and %5D are url-encoded [ and ]
        });
      }

      window.open(currentUrl + newHref, "_blank");
    });

    $("#grantSections").on("change", function () {
      var selectedVals = $(this).val();

      if (selectedVals.length > 0) {
        $("#downloadTemplate").attr("disabled", false);
      } else {
        $("#downloadTemplate").attr("disabled", true);
      }
    });

    if ($("#allowAllOrganisations").is(":checked")) {
      $("#organisations").closest(".govuk-form-group").attr("hidden", "hidden");
      $("#organisations").val("");
    }

    $("#allowAllOrganisations").click(function () {
      if ($("#allowAllOrganisations").is(":checked")) {
        $("#organisations")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
        $("#organisations").val("").trigger("chosen:updated");
        $("#downloadTemplate").attr("href", downloadHref);
        $("#downloadTemplate").attr("disabled", false);
      } else {
        $("#organisations").closest(".govuk-form-group").removeAttr("hidden");
      }
    });
    $("#allowParticularOrganisations").click(function () {
      if ($("#allowParticularOrganisations").is(":checked")) {
        $("#organisations").closest(".govuk-form-group").removeAttr("hidden");
        $("#downloadTemplate").attr("disabled", true);
      } else {
        $("#organisations")
          .closest(".govuk-form-group")
          .attr("hidden", "hidden");
        $("#organisations").val("").trigger("chosen:updated");
        $("#downloadTemplate").attr("disabled", false);
      }
    });

    $("#organisations").on("change", function () {
      var selectedVals = $(this).val();

      if (selectedVals.length > 0) {
        $("#downloadTemplate").attr("disabled", false);
      } else {
        $("#downloadTemplate").attr("disabled", true);
      }
    });
  }

  if ($("#previewMessage").length > 0) {
    setTimeout(function () {
      location.reload();
    }, 10000);
  }
  
  if (isInSelectFinancialYearPage()) {
    var dataGridUrl = $(".data-grid").attr("url");
  }

  if (isInScheamAssociatePage()) {
    if (!$("#allow-update").is(":checked")) {
      $(".enableUpload").removeAttr("hidden");
    }
    $("#allow-update").on("change", function () {
      if ($(this).is(":checked")) {
        $(".enableUpload").attr("hidden", "hidden");
      } else {
        $(".enableUpload").removeAttr("hidden");
      }
    });
    $("#disallow-update").on("change", function () {
      if ($(this).is(":checked")) {
        $(".enableUpload").removeAttr("hidden");
      } else {
        $(".enableUpload").attr("hidden", "hidden");
      }
    });
  }
};
